import React from "react";
import { connect } from "react-redux";
import AccessoryCard from "src/components/Accessories/Blocks/DealCard";
import Loading from "src/components/Accessories/Elements/Loading";
import NoResults from "src/components/Accessories/Elements/NoResults";
import { ApplicationStore } from "src/store";
import { getSelectedPaymentType } from "src/store/selectors/vehicles";
import "src/components/Accessories/accessories.scss";

interface Props {
    vin: string;
    onAccessoriesChange(): void;
}

export const DealView = ({
    vin,
    loading,
    hasAccessories,
    accessories = [],
    onAccessoriesChange,
}: Props & ReturnType<typeof mapStateToProps>) => {
    return (
        <div className={`accessories_deal_view`}>
            {hasAccessories ? (
                accessories.map((id) => (
                    <AccessoryCard
                        key={`${vin}:${id}`}
                        vin={vin}
                        accessoryId={id}
                        onAccessoriesChange={onAccessoriesChange}
                    />
                ))
            ) : loading ? (
                <Loading />
            ) : (
                <NoResults />
            )}
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => ({
    uuid: state.deal.uuid!,
    paymentType: getSelectedPaymentType(state, vin),
    loading: state.accessories?.[vin]?.isLoading,
    hasAccessories: !!state.accessories?.[vin]?.available?.[getSelectedPaymentType(state, vin)]?.length,
    accessories: state.accessories?.[vin]?.available?.[getSelectedPaymentType(state, vin)],
});

export default connect(mapStateToProps)(DealView);
